$(document).ready(function () {
  $(".GalleryBox").owlCarousel({
    loop: false,
    margin: 15,
    nav: true,
    dots: true,
    autoplay: false,
    navText: ['<span class="left"></span>', '<span class="right"></span>'],
    responsive: {
      0: {
        items: 2,
      },
      600: {
        items: 3,
      },
      1000: {
        items: 4,
      },
    },
  });
});
